var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleSubGrid',{attrs:{"modifiers":_vm.buttonsClass}},[_vm._l((_vm.gridPlaceholder),function(grid,index){return [_c(grid,{key:`grid${index}`,tag:"component"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }